import React from 'react';
import PropTypes from 'prop-types';

const Marker02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.0001 17C8.0001 17 14.261 11.4348 14.261 7.26087C14.261 3.80309 11.4579 1 8.0001 1C4.54231 1 1.73923 3.80309 1.73923 7.26087C1.73923 11.4348 8.0001 17 8.0001 17Z"
      stroke={color}
      strokeWidth="1.66667"
    />
    <path
      d="M10.0004 7.00013C10.0004 8.1047 9.10492 9.00013 8.00035 9.00013C6.89578 9.00013 6.00035 8.1047 6.00035 7.00013C6.00035 5.89556 6.89578 5.00013 8.00035 5.00013C9.10492 5.00013 10.0004 5.89556 10.0004 7.00013Z"
      stroke={color}
      strokeWidth="1.66667"
    />
  </svg>

);

Marker02Icon.propTypes = {
  color: PropTypes.string,
};

export default Marker02Icon;
